import React, {ReactNode, useState} from 'react'
import {Modal} from 'react-bootstrap'
import Translator from '../translate/Translator'
import {Guid} from 'guid-typescript'

export type PopupProvides = {
  handleClose: () => void
}

function BasePopup(props: {
  title: string
  modalOpener?: ReactNode
  onClick?: () => boolean
  children: ((props: PopupProvides) => React.ReactNode) | React.ReactNode
  size?: 'sm' | 'lg' | 'xl'
  wrapperClassName?: string
  isDisabled?: boolean
  fullscreen?: boolean
}) {
  const [modalShow, setModalShow] = useState(false)
  const handleModalClose = () => setModalShow(false)
  const handleModalShow = () => setModalShow(true)

  const guid = Guid.create().toString()

  return (
    <>
      <div
        className={props.wrapperClassName}
        onClick={() => {
          if (props.isDisabled) return
          if (props.onClick) {
            const result = props.onClick()

            if (result) {
              handleModalShow()
            }
          } else {
            handleModalShow()
          }
        }}
      >
        {props.modalOpener}
      </div>

      <Modal
        size={props.size}
        fullscreen={props.fullscreen ? true : undefined}
        show={modalShow}
        onHide={handleModalClose}
        centered
        id={guid}
        contentClassName='border'
      >
        <Modal.Header closeButton>
          <h5 className='modal-title'>
            <Translator name={props.title} />
          </h5>
        </Modal.Header>
        <Modal.Body>
          {typeof props.children === 'function'
            ? props.children({
                handleClose: handleModalClose,
              })
            : React.Children.only(props.children)}
        </Modal.Body>
      </Modal>
    </>
  )
}

export default BasePopup
